export function fmtUSDC(value: string | number | bigint | null | undefined): string {
  if (value === undefined || value === null) return '';
  const s = String(value);
  try {
    const raw = BigInt(s);
    const whole = Number(raw) / 1e6;
    if (!isFinite(whole)) return s;
    return whole.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch {
    const num = Number(s);
    if (!isFinite(num)) return s;
    const whole = num / 1e6;
    return whole.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}


